import {SPECIAL_BUILDING_TOKENS} from '../../../constants/tokens';
import {D4_SHOOTING_DAMAGE_FOR_1_BUILDING_DAMAGE} from '../../../configs/war';

/**
 * Промахнулся ли выстрел: урона по цели не будет. По отряду и по крепости
 * достаточно любого урона, обычное строение повреждается только от
 * D4_SHOOTING_DAMAGE_FOR_1_BUILDING_DAMAGE.
 *
 * Судит по итогу выстрела в состоянии партии, поэтому подходит и после
 * переброса. Флаг isBadLuck из экшена переброса для этого не годится: там он
 * значит «урон не вырос», и попавший снова выстрел считался бы промахом.
 *
 * @param {Object} action — запись из pendingShootingActions
 * @param {Object} [specialBuildings] — спецстроения по ячейкам
 * @returns {boolean}
 */
export const checkIfShotMissed = (action, specialBuildings = {}) => {
  const damage = action?.damage || 0;
  const isFortressTarget = specialBuildings?.[action?.targetHexKey] === SPECIAL_BUILDING_TOKENS.FORTRESS;
  return action?.targetUnitId || isFortressTarget
    ? damage <= 0
    : damage < D4_SHOOTING_DAMAGE_FOR_1_BUILDING_DAMAGE;
};
